package dev.danko.roblox_craft_ai.pages.legal.ru

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initTermsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/ru/terms.md", FrontMatterElement.Builder { addScalar("title", "Условия использования"); addScalar("lang", "ru"); }))
}

@Page("/legal/ru/terms")
@Layout(".components.layouts.LegalLayout")
@Composable
fun TermsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("условия-использования") }) {
        org.jetbrains.compose.web.dom.Text("Условия использования")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Дата вступления в силу:")
        }
        org.jetbrains.compose.web.dom.Text(" 3 октября 2026 г.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Настоящие Условия использования («Условия») регулируют пользование сервисом Craftiva AI («Сервис»), доступным по адресу [SITE_URL] и через плагин Craftiva для Roblox Studio. Оператор Сервиса — ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("[OPERATOR_NAME]")
        }
        org.jetbrains.compose.web.dom.Text(", [OPERATOR_STATUS], регистрационный номер [REG_NUMBER], [ADDRESS], [COUNTRY] («мы»). Связь: [SUPPORT_EMAIL].")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Пользуясь Сервисом, вы соглашаетесь с этими Условиями, нашей ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/ru/privacy") {
            org.jetbrains.compose.web.dom.Text("Политикой конфиденциальности")
        }
        org.jetbrains.compose.web.dom.Text(" и ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/ru/refunds") {
            org.jetbrains.compose.web.dom.Text("Политикой возвратов")
        }
        org.jetbrains.compose.web.dom.Text(". Если вы не согласны, не пользуйтесь Сервисом.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Юридически значимой является ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/en/terms") {
            org.jetbrains.compose.web.dom.Text("английская версия")
        }
        org.jetbrains.compose.web.dom.Text(" этих Условий; русская версия приведена для удобства.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Craftiva AI — независимый инструмент. Он ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("не является официальным продуктом Roblox и не связан с Roblox Corporation, не одобрен и не спонсируется ею")
        }
        org.jetbrains.compose.web.dom.Text(". «Roblox» и «Roblox Studio» — зарегистрированные товарные знаки Roblox Corporation.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("1-что-делает-сервис") }) {
        org.jetbrains.compose.web.dom.Text("1. Что делает Сервис")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Сервис с помощью искусственного интеллекта помогает создавать контент для игр Roblox: Luau-скрипты, 3D-модели, анимации и Rojo-проекты, а также отправлять их в Roblox Studio через наш плагин. Результаты создаются автоматически моделями ИИ сторонних провайдеров и нашей обработкой. Они могут содержать ошибки, работать не так, как ожидается, и должны быть проверены вами перед использованием.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("2-возрастные-требования") }) {
        org.jetbrains.compose.web.dom.Text("2. Возрастные требования")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Пользоваться Сервисом можно с ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("13 лет")
            }
            org.jetbrains.compose.web.dom.Text(". Если вы живёте в Европейской экономической зоне или Великобритании и вам меньше 16 лет, пользоваться Сервисом можно только с согласия родителя или законного представителя.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Дети младше 13 лет могут пользоваться Сервисом только вместе с родителем или законным представителем — через аккаунт родителя и под его присмотром.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Совершать покупки могут только совершеннолетние (18+).")
            }
            org.jetbrains.compose.web.dom.Text(" Если вам меньше 18 лет, покупку должен совершить родитель или законный представитель, который принимает эти Условия от вашего имени.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("3-аккаунты") }) {
        org.jetbrains.compose.web.dom.Text("3. Аккаунты")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Часть возможностей Сервиса доступна без аккаунта. Тогда ваши работы привязываются к токену сессии, который хранится в вашем браузере.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Чтобы сохранять работы на разных устройствах и покупать кредиты, нужно войти по email с помощью одноразовой ссылки. Берегите доступ к своей почте: войти в аккаунт может любой, кто откроет ссылку.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Один аккаунт — для одного человека. Вы отвечаете за действия, совершённые в вашем аккаунте.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("4-кредиты-тарифы-и-оплата") }) {
        org.jetbrains.compose.web.dom.Text("4. Кредиты, тарифы и оплата")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Действия в Сервисе стоят ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("кредиты")
            }
            org.jetbrains.compose.web.dom.Text(" (например, скрипт — 1 кредит, 3D-модель — 10 кредитов). Актуальная стоимость, тарифы и цены указаны на ")
            com.varabyte.kobweb.silk.components.navigation.Link("/pricing") {
                org.jetbrains.compose.web.dom.Text("странице тарифов")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Бесплатный тариф и платные подписки включают определённое количество кредитов в месяц. ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Месячные кредиты не переносятся")
            }
            org.jetbrains.compose.web.dom.Text(" на следующий месяц. ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Пакеты кредитов")
            }
            org.jetbrains.compose.web.dom.Text(" — разовые покупки; купленные кредиты не сгорают, пока ваш аккаунт активен.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Кредиты не имеют денежной стоимости, их нельзя передать другому или обменять на деньги, кроме случаев, предусмотренных законом или ")
            com.varabyte.kobweb.silk.components.navigation.Link("/legal/ru/refunds") {
                org.jetbrains.compose.web.dom.Text("Политикой возвратов")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Если генерация не удалась из-за ошибки на нашей стороне, кредиты за неё возвращаются автоматически.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Подписка продлевается автоматически в конце каждого расчётного периода, пока вы её не отмените. Отменить можно в любой момент; подписка действует до конца оплаченного периода.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Мы можем менять цены и стоимость действий. Новая цена действующей подписки применяется со следующего расчётного периода, о чём мы сообщим заранее.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Оплата.")
        }
        org.jetbrains.compose.web.dom.Text(" Заказы оформляет наш онлайн-реселлер ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Paddle.com")
        }
        org.jetbrains.compose.web.dom.Text(". Paddle.com является продавцом (Merchant of Record) по всем нашим заказам. Paddle отвечает на все вопросы, связанные с оплатой, и оформляет возвраты. Платёжные данные вводятся на странице оплаты Paddle и к нам не попадают. К покупке также применяются ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.paddle.com/legal/checkout-buyer-terms") {
            org.jetbrains.compose.web.dom.Text("Условия для покупателей Paddle")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("5-ваш-контент-и-результаты-генерации") }) {
        org.jetbrains.compose.web.dom.Text("5. Ваш контент и результаты генерации")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Ваши данные.")
            }
            org.jetbrains.compose.web.dom.Text(" Все права на запросы, изображения и другие материалы, которые вы отправляете («Входные данные»), остаются за вами. Вы подтверждаете, что имеете право их отправлять и что они не нарушают чужих прав.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Результаты.")
            }
            org.jetbrains.compose.web.dom.Text(" В той мере, в какой у нас есть права на результаты, созданные для вас («Результаты»), мы передаём их вам, и вы можете использовать Результаты в своих играх Roblox, в том числе коммерческих. Модели ИИ могут выдавать похожие результаты разным пользователям, поэтому Результаты могут быть не уникальными.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Вы отвечаете за то, как используете Результаты, включая соблюдение ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://en.help.roblox.com/hc/en-us/articles/115004647846") {
                org.jetbrains.compose.web.dom.Text("Условий использования Roblox")
            }
            org.jetbrains.compose.web.dom.Text(" и Правил сообщества Roblox, и за проверку того, что они не нарушают права третьих лиц.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Вы разрешаете нам хранить и обрабатывать Входные данные и Результаты, чтобы предоставлять, защищать и улучшать Сервис, включая автоматическую модерацию. Мы не используем ваш контент для обучения моделей ИИ. Провайдеры ИИ обрабатывают запросы по своим условиям API — подробнее в ")
            com.varabyte.kobweb.silk.components.navigation.Link("/legal/ru/privacy") {
                org.jetbrains.compose.web.dom.Text("Политике конфиденциальности")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("6-допустимое-использование") }) {
        org.jetbrains.compose.web.dom.Text("6. Допустимое использование")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Запрещается использовать Сервис, чтобы:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("создавать или запрашивать контент, который незаконен, носит откровенно сексуальный характер, сексуализирует несовершеннолетних, пропагандирует насилие, ненависть, самоповреждение или травлю либо нарушает Правила сообщества Roblox;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("создавать читы, эксплойты, вредоносный код, скрипты для обхода защиты Roblox или для вреда аккаунтам и устройствам других игроков;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("нарушать права на интеллектуальную собственность или неприкосновенность частной жизни, выдавать себя за других;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("обходить модерацию, лимиты или оплату, передавать или перепродавать доступ к аккаунту, обращаться к Сервису автоматически иначе, чем через наш плагин и публичные интерфейсы;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("мешать работе Сервиса или его провайдеров, атаковать их.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Запросы проверяются автоматическими фильтрами. Заблокированные запросы отклоняются и записываются с коротким фрагментом, чтобы мы могли разобраться с нарушениями. Мы можем приостановить или закрыть аккаунт за нарушение этих правил. В серьёзных случаях неиспользованные кредиты могут быть аннулированы в пределах, допустимых законом.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("7-доступность-и-изменения") }) {
        org.jetbrains.compose.web.dom.Text("7. Доступность и изменения")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Сервис зависит от сторонних провайдеров ИИ и инфраструктуры. Мы стараемся поддерживать его работу, но не гарантируем бесперебойность. Мы можем добавлять, менять и убирать функции и провайдеров. Мы можем менять эти Условия; о существенных изменениях сообщим на сайте или по email не менее чем за 14 дней. Продолжая пользоваться Сервисом после изменений, вы принимаете новые Условия.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("8-отказ-от-гарантий-и-ответственность") }) {
        org.jetbrains.compose.web.dom.Text("8. Отказ от гарантий и ответственность")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Сервис и все Результаты предоставляются ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("«как есть»")
            }
            org.jetbrains.compose.web.dom.Text(", без каких-либо гарантий, в пределах, допустимых законом. Мы не гарантируем, что Результаты точны, безопасны, безошибочны или подходят для конкретной цели.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("В пределах, допустимых законом, мы не отвечаем за косвенные убытки, упущенную выгоду, потерю данных и ущерб от использования Результатов в ваших проектах. Наша общая ответственность по любому требованию ограничена суммой, которую вы заплатили нам за 12 месяцев до него.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ничто в этих Условиях не ограничивает ответственность, которую нельзя ограничить по закону, и ваши права потребителя.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("9-прекращение") }) {
        org.jetbrains.compose.web.dom.Text("9. Прекращение")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Вы можете в любой момент перестать пользоваться Сервисом и сами удалить аккаунт в разделе «Настройки → Аккаунт» (см. ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/ru/privacy") {
            org.jetbrains.compose.web.dom.Text("Политику конфиденциальности")
        }
        org.jetbrains.compose.web.dom.Text("). Активную подписку перед этим нужно отменить. Мы можем приостановить или прекратить доступ при нарушении этих Условий или по требованию закона. Разделы 5, 8 и 10 продолжают действовать после прекращения.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("10-применимое-право-и-споры") }) {
        org.jetbrains.compose.web.dom.Text("10. Применимое право и споры")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Эти Условия регулируются правом [COUNTRY]. Если вы потребитель, за вами сохраняется защита обязательных норм права страны вашего проживания, и вы можете обратиться в суд по месту жительства. Сначала, пожалуйста, напишите нам на [SUPPORT_EMAIL] — большинство вопросов решается быстро.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("11-контакты") }) {
        org.jetbrains.compose.web.dom.Text("11. Контакты")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("[OPERATOR_NAME], [ADDRESS], [COUNTRY] · [SUPPORT_EMAIL]")
    }
}
